try {
  var $ = jQuery;

  $(function () {

      window.addEventListener('load', AOS.refresh);

      /**
       * Action submit pour le formulaire de connexion
       */
      $('form#login').on('submit', function (e) {
          e.preventDefault();
          $('.form-left.wpcf7.form-account').addClass("loading");
          $('form#login p.status').show().text(ajax_login_object.loadingmessage);

          $.ajax({
              type: 'POST',
              dataType: 'json',
              url: ajax_login_object.ajaxurl,
              data: {
                  'action': 'ajaxlogin', //calls wp_ajax_nopriv_ajaxlogin
                  'username': $('form#login #username').val(),
                  'password': $('form#login #password').val(),
                  'security': $('form#login #security').val()
              },
              success: function (data) {
                  $('form#login p.status').html(data.message);
                  if (data.loggedin == true) {
                      location.reload();
                  }
              },
              complete: function () {
                  $('.form-left.wpcf7.form-account').removeClass("loading");
              },
              error: function (jqXHR, textStatus, errorThrown) {
                  $('form#login p.status').text(textStatus);
              }
          });

      });

      /**
       * Action submit pour le formulaire de pre connexion
       */
      $('form#pre-registraion-form').on('submit', function (e) {
          e.preventDefault();
          $('.form-right.wpcf7.form-account').addClass("loading");
          $('form#pre-registraion-form p.status').show().text(ajax_pre_register.loadingmessage);

          $.ajax({
              type: 'POST',
              dataType: 'json',
              url: ajax_pre_register.ajaxurl,
              data: {
                  'action': 'verif_mail',
                  'mail': $('form#pre-registraion-form #vb_email').val(),
              },
              success: function (data) {
                  $('form#pre-registraion-form p.status').html(data.message);

                  if (data.redirect) {
                      // data.redirect contains the string URL to redirect to
                      window.location.href = data.redirect;
                  }
              },
              complete: function () {
                  $('.form-right.wpcf7.form-account').removeClass("loading");
              },
              error: function (jqXHR, textStatus, errorThrown) {
                  $('form#pre-registraion-form p.status').text(textStatus);
              }
          });

      });

      /**
       * Action submit pour le formulaire de téléchargement de documentations
       */
      $('form#form-download').on('submit', function (e) {
          e.preventDefault();
          $('form#form-download').addClass("loading");
          var form = $(this);
          var status = form.find('p.status');
          status.show().text(ajax_pre_download.loadingmessage);

          $.ajax({
              type: 'POST',
              dataType: 'json',
              url: ajax_pre_download.ajaxurl,
              data: {
                  'action': 'verif_download',
                  'category': form.find('#category').val(),
                  'post': form.find('#post').val()
              },
              success: function (data) {
                  status.html(data.message);

                  if (data.redirect) {
                      // data.redirect contains the string URL to redirect to
                      window.location.href = data.redirect;
                  }

                  if (data.file) {
                      downloadURI(data.file.url, data.file.name);
                  }
              },
              complete: function () {
                  $('form#form-download').removeClass("loading");

              },
              error: function (jqXHR, textStatus, errorThrown) {
                  status.text(textStatus);
              }
          });

      });

      function downloadURI(url, name) {
          var link = document.createElement("a");
          link.download = name;
          link.href = url;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          delete link;
      }

      /**
       * Créer un nouveau compte
       */
      /*$('body').on('click', '#btn-new-user', function (event) {

          if (event.preventDefault) {
              event.preventDefault();
          } else {
              event.returnValue = false;
          }

          if ($('.checkbox_policy').is(':checked')) {

              $('form#register-form p.status').show().text(ajax_pre_register.loadingmessage);

              // Collect data from inputs
              var reg_nonce = $('#vb_new_user_nonce').val();
              var reg_user = $('#vb_username').val();
              var reg_pass = $('#vb_pass').val();

              var reg_civility = $('#vb_civility').val();
              var reg_name = $('#vb_name').val();
              var reg_firstname = $('#vb_firstname').val();
              var reg_company = $('#vb_company').val();
              var reg_mail = $('#vb_email').val();
              var reg_phone = $('#vb_phone').val();

              //AJAX URL where to send data (from localize_script)
              var ajax_url = vb_reg_vars.vb_ajax_url;

              // Data to send
              var data = {
                  action: 'register_user',
                  nonce: reg_nonce,
                  user: reg_user,
                  pass: reg_pass,
                  mail: reg_mail,
                  name: reg_name,
                  civility : reg_civility,
                  firstname : reg_firstname,
                  company : reg_company,
                  phone : reg_phone
                  //nick: reg_nick,
              };

              // Do AJAX request
              $.post(ajax_url, data, function (response) {
                  // If we have response
                  if (response) {

                      if (response === '1') {
                          // If user is created
                          $('form#register-form p.status').show().text(translation.success_inscription);


                          setTimeout(function () {
                              window.location.href = "/";
                         }, 3500);

                      } else {
                          $('form#register-form p.status').show().text(response);
                      }
                  }
              });
          }
          else
          {
              $('form#register-form p.status').show().text('Please accept the privacy policy');
          }
      });*/


      /**
       * Modification des informations du compte utilsateur
       */
      /*$('body').on('click', '#btn-update-user', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (event.preventDefault) {
              event.preventDefault();
          } else {
              event.returnValue = false;
          }


          $('form#update-form p.status').show().text(ajax_pre_register.loadingmessage);

          // Collect data from inputs
          var reg_nonce = $('#vb_maj_user_nonce').val();
          var reg_user = $('#vb_username').val();
          var reg_pass = $('#vb_pass').val();
          var vb_username = $('#vb_username').val();

          var reg_civility = $('#vb_civility').val();
          var reg_name = $('#vb_name').val();
          var reg_firstname = $('#vb_firstname').val();
          var reg_company = $('#vb_company').val();
          var reg_mail = $('#vb_email').val();
          var reg_phone = $('#vb_phone').val();

          // AJAX URL where to send data (from localize_script)
          var ajax_url = vb_reg_vars.vb_ajax_url;

          // Data to send
          var data = {
              action: 'update_user',
              nonce: reg_nonce,
              //pass: reg_pass,
              mail: reg_mail,
              name: reg_name,
              //user: vb_username,
              civility : reg_civility,
              firstname : reg_firstname,
              company : reg_company,
              phone : reg_phone
          };

            // Do AJAX request
          $.post(ajax_url, data, function (response) {

              // If we have response
              if (response) {

                  if (response === '1') {
                      // If user is created
                      $('form#update-form p.status').show().text('Update profile successfully. Reload...');

                      setTimeout(function () {
                          location.reload();
                      }, 1000);
                  } else {

                      $('form#update-form p.status').show().text(response);
                  }
              }
          });
      });*/

    $('.lazyload').lazy();

    var sayWho = function () {

      navigator.sayswho = (function () {
        var ua = navigator.userAgent, tem,
          M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
          tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
          return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
          tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
          if (tem != null)
            return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null)
          M.splice(1, 1, tem[1]);
        return M.join(' ');
      })();
      var who = navigator.sayswho.split(" ");
      var browser = who[0].toLowerCase();
      var version = parseInt(who[1]);

      $("body").addClass(browser);
      $("body").addClass(browser + version);

    };

    var homeInit = function () {

      if ($('#carousel-home-wrapper .owl-carousel .item').length > 1) {

        $('#carousel-home-wrapper .owl-carousel').owlCarousel({
          items: 1,
          margin: 1,
          loop: true,
          dots: false
        });

      }

    };


    var getNewsletterForm = function () {

      var $elt = $('#site-footer .wpcf7-form-control-wrap.email');

      if ($elt.length) {
        return $elt.closest('form');
      }

      return false;
    };

    var newslettersValidationAction = function (e) {
      e.preventDefault();
      e.stopPropagation();

      var email = $(this).find('[type=email]').val();

      // requete function.php
      // si email existe deja
      // error message
      // sinon off event and submit

    };

    var newslettersValidation = function () {

      var $form = getNewsletterForm();

      if (false !== $form) {
        $('body').on('submit', $form, newslettersValidationAction);
      }

    };

      /*
  *  new_map
  *
  *  This function will render a Google Map onto the selected jQuery element
  *
  *  @type	function
  *  @date	8/11/2013
  *  @since	4.3.0
  *
  *  @param	$el (jQuery element)
  *  @return	n/a
  */

      function new_map( $el ) {

          // var
          var $markers = $el.find('.marker');


          // vars
          var args = {
              zoom		: 16,
              center		: new google.maps.LatLng(0, 0),
              mapTypeId	: google.maps.MapTypeId.ROADMAP
          };


          // create map
          var map = new google.maps.Map( $el[0], args);


          // add a markers reference
          map.markers = [];


          // add markers
          $markers.each(function(){

              add_marker( $(this), map );

          });


          // center map
          center_map( map );


          // return
          return map;

      }

      /*
      *  add_marker
      *
      *  This function will add a marker to the selected Google Map
      *
      *  @type	function
      *  @date	8/11/2013
      *  @since	4.3.0
      *
      *  @param	$marker (jQuery element)
      *  @param	map (Google Map object)
      *  @return	n/a
      */

      function add_marker( $marker, map ) {

          // var
          var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

          // create marker
          var marker = new google.maps.Marker({
              position	: latlng,
              icon: '/wp-content/themes/ciplus/images/marker.png',
              map: map
          });

          // add to array
          map.markers.push( marker );

          // if marker contains HTML, add it to an infoWindow
          if( $marker.html() )
          {
              // create info window
              var infowindow = new google.maps.InfoWindow({
                  content		: $marker.html()
              });

              // show info window when marker is clicked
              google.maps.event.addListener(marker, 'click', function() {

                  infowindow.open( map, marker );

              });
          }

      }

      /*
      *  center_map
      *
      *  This function will center the map, showing all markers attached to this map
      *
      *  @type	function
      *  @date	8/11/2013
      *  @since	4.3.0
      *
      *  @param	map (Google Map object)
      *  @return	n/a
      */

      function center_map( map ) {

          // vars
          var bounds = new google.maps.LatLngBounds();

          // loop through all markers and create bounds
          $.each( map.markers, function( i, marker ){

              var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

              bounds.extend( latlng );

          });

          // only 1 marker?
          if( map.markers.length == 1 )
          {
              // set center of map
              map.setCenter( bounds.getCenter() );
              map.setZoom( 16 );
          }
          else
          {
              // fit to bounds
              map.fitBounds( bounds );
          }

      }

      function smoothScroll()
      {

          $("a[href*='#']").on('click', function (event) {

              // Make sure this.hash has a value before overriding default behavior
              if (this.hash !== "") {
                  // Prevent default anchor click behavior
                  event.preventDefault();

                  // Store hash
                  var hash = this.hash;

                  // Using jQuery's animate() method to add smooth page scroll
                  // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
                  $('html, body').animate({
                      scrollTop: $(hash).offset().top
                  }, 800, function () {

                      // Add hash (#) to URL when done scrolling (default click behavior)
                      //window.location.hash = hash;
                  });
              }
          });
      }

      var map = null;

      var cible = $('.bloc-numbers.blocs.section')[0];

      var options = {
          threshold: 0.5 /* 50% */
      };

      var observer = new IntersectionObserver(
          onIntersection,
          options
      );



      $(document).ready(function(){

          AOS.init();

          $('.acf-map').each(function(){
              // create map
              map = new_map( $(this) );
          });


          //lance l'observer
          if(cible)
          {
              observer.observe(cible);
          }

          $('.menu-mobile').click(function () {
              $(this).parent().toggleClass('active');
          })

          //fix pour mettre en gras le dernier mot d'un titre
          $('.titre--blue').html(function(){

              if(!$(this).find('strong')[0]) {
                  var text= $(this).text().trim().split(" ");
                  var last = text.pop();
                  return text.join(" ") + " <strong>" + last + "</strong>";
              }

          });
          
          //autofix size 
          var containers = $('.container-size-auto-js')
          
          containers.each(function () {
              var elems = $(this).find('.elem-size-auto-js')
              var cpt = 0
              var height = 0

              elems.each(function () {
                  cpt++;

                  if(this.getBoundingClientRect().height > height) {
                      height = this.getBoundingClientRect().height
                  }

                  if(cpt === elems.length) {
                      elems.css({"height":height+"px"})
                  }
              })
          })

      });

      //anim de l'incrémentation des chiffres
      function onIntersection(entries) {
          var target;
          entries.forEach(function(entry) {
              if (entry.intersectionRatio > 0.5) {

                  $('.bloc--number .number').each(function (index, value) {
                      var number = $(value).data("number");

                      if(typeof $(value).attr('data-periode') !== 'undefined') {
                          var now = new Date();
                          var dateBegin = new Date($(value).attr('data-date'));
                              dateBegin.setHours(0);
                              dateBegin.setMinutes(0);
                              dateBegin.setSeconds(1);

                          var periode = parseFloat($(value).attr('data-periode'));
                          var dateDiff = now - dateBegin;
                          var seconds = Math.floor(dateDiff / 1000);

                          number = Math.round(number + periode * seconds);
                      }

                      var cpt = 0;
                      var increment = 1;
                      var speed = 4;

                      if(number > 1000000) {
                          cpt = number - 500
                      } else if(number > 1500) {
                          cpt = Math.round(number / speed) * (speed-1)
                      }


                      var interval = setInterval(function () {
                          if( cpt < number ) {
                              cpt+= increment;
                              $(value).html(cpt);
                          }
                          else
                          {
                              incrementInTime(value);
                              clearInterval(interval);
                          }
                      },0.25)
                  });

              observer.unobserve(cible);
          }
      })

      }

      function incrementInTime(elem) {

          if(typeof $(elem).attr('data-offset') !== 'undefined') {
              var increment = parseFloat($(elem).attr('data-periode'));
              var number = parseFloat($(elem).attr('data-offset'));
              var date = new Date($(elem).attr('data-date'));
                  date.setHours(0);
                  date.setMinutes(0);
                  date.setSeconds(1);

              var dateNow, dateDiff, seconds, total;

              setInterval(function () {
                  dateNow = new Date();
                  dateDiff = dateNow - date;
                  seconds = Math.floor(dateDiff / 1000);

                  total = Math.round(number + increment * seconds);

                  $(elem).html(total);
              }, 1000);
          }

      }

      function getRandomArbitrary(min, max) {
          return Math.random() * (max - min) + min;
      }


      //click sur les condtions des formulaires -> RGPD
      $('.policy .help-block, .check-policy .wpcf7-list-item-label').click(function () {
          window.open(location.protocol + '//' + location.host + '/privacy-policy', '_blank');
      });


    homeInit();

      newslettersValidation();
    sayWho();

  smoothScroll();

  });


}
catch (err) {
  console.log(err);
}